<p-button
  [pTooltip]="toolTip"
  [tooltipOptions]="{showDelay: toolTipDelay, tooltipStyleClass: 'nxTooltip'}"
  [disabled]="disabled"
  [label]="text"
  [ngClass]="width? width: ''">
  <ng-template *ngIf="icon" pTemplate="icon">
    <i [ngClass]="icon"></i>
  </ng-template>
</p-button>

